// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

// app/javascript/controllers/index.js

import { application } from "./application"

import ActionController from "./action_controller"
application.register("action", ActionController)

import AvatarPickerController from "./avatar_picker_controller"
application.register("avatar-picker", AvatarPickerController)

import CopyController from "./copy_controller"
application.register("copy", CopyController)

import DataTableController from "./data_table_controller"
application.register("data-table", DataTableController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MonacoController from "./monaco_controller"
application.register("monaco", MonacoController)

import StepActionController from "./step_action_controller"
application.register("step-action", StepActionController)

import WorkflowBuilderController from "./workflow_builder_controller"
application.register("workflow-builder", WorkflowBuilderController)

import WorkflowExecutionEventController from "./workflow_execution_event_controller"
application.register("workflow-execution-event", WorkflowExecutionEventController)

import WorkflowStreamingController from "./workflow_streaming_controller"
application.register("workflow-streaming", WorkflowStreamingController)

import AiRecordController from "./ai_record_controller"
application.register("ai-record", AiRecordController)

import AiRecordLauncherController from "./ai_record_launcher_controller"
application.register("ai-record-launcher", AiRecordLauncherController)